'use client';

import Image from 'next/image';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';

import { compressImage } from '../../lib/compressImage';

function BasicDropzone({ getFile }: { getFile: CallableFunction }) {
  const [file, setFile] = useState<File & { preview: string }>();

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: 3e6, // 3Mb
    onDrop: async (acceptedFiles) => {
      const compressedImage = await compressImage(acceptedFiles[0]);
      const timestamp = Date.now();
      const newFileName = `${timestamp}.webp`;

      const modifiedFile = new File([compressedImage], newFileName, {
        type: 'image/webp'
      }) as File & { preview: string };

      modifiedFile.preview = URL.createObjectURL(modifiedFile);

      setFile(modifiedFile as File & { preview: string });
      getFile(modifiedFile);
    }
  });

  return (
    <section className="container mb-8 cursor-pointer rounded-md border-2 border-dashed border-slate-400 bg-slate-100 py-9 dark:border-slate-100 dark:bg-slate-600">
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p>Перетащите файл или выбирите</p>
      </div>
      <div>
        <button onClick={() => setFile(undefined)}>Удалить</button>
        {!!file && (
          <Image
            className="m-auto"
            width={200}
            height={200}
            alt={file?.name}
            src={file?.preview}
            onLoad={() => {
              URL.revokeObjectURL(file?.preview);
            }}
          />
        )}
      </div>
    </section>
  );
}

export default BasicDropzone;
